import { postMessageFeedbackUseCase } from "@src/cloud-connect/rag/use-cases/post-message-feedback-use-case";

export const useSendFeedback = (namespace: string | null) => {
  const sendFeedback = (messageId: string, useful: boolean) =>
    postMessageFeedbackUseCase(namespace, messageId, useful);

  return {
    sendPositiveFeedback: (messageId: string) => sendFeedback(messageId, true),
    sendNegativeFeedback: (messageId: string) => sendFeedback(messageId, false),
  };
};
